import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { registerServiceWorker } from './pwa/register'

// Apply saved theme before first render to avoid flash
const savedTheme = localStorage.getItem("theme");
if (savedTheme === "dark") {
  document.documentElement.classList.add("dark");
}

createRoot(document.getElementById("root")!).render(<App />);

// Service worker is registered after mount: updates are only ever applied
// from the in-app notification (see src/pwa/register.ts), never silently.
registerServiceWorker();
